import { matchRows, officialRows } from "./helpers";
import type { MatchInfo } from "./helpers";
import { Empty } from "./parts";

const InfoTab = ({ match }: { match?: MatchInfo }) => {
  const info = matchRows(match);
  const officials = officialRows(match);
  if (!info.length && !officials.length) return <Empty>No match information has been added yet.</Empty>;
  return (
    <div className="two">
      {info.length ? (
        <div className="box">
          <div className="box-h">
            <h3>Match</h3>
          </div>
          <dl className="dl">
            {info.map(([k, v]) => (
              <div key={k} style={{ display: "contents" }}>
                <dt>{k}</dt>
                <dd>{v}</dd>
              </div>
            ))}
          </dl>
        </div>
      ) : null}
      {officials.length ? (
        <div className="box">
          <div className="box-h">
            <h3>Officials</h3>
          </div>
          <dl className="dl">
            {officials.map(([k, v], i) => (
              <div key={`${k}-${i}`} style={{ display: "contents" }}>
                <dt>{k}</dt>
                <dd>{v}</dd>
              </div>
            ))}
          </dl>
        </div>
      ) : null}
    </div>
  );
};

export default InfoTab;
